import{IS_LOCAL_STORAGE as e}from"./general.js";const o="base.ui.components.url";e&&localStorage.getItem(o),e&&localStorage.getItem(o);export{o as UI_COMPONENTS_URL_KEY};
